<template>
  <div>
    <!--<div id="app-auth-container">
      <firebase-ui></firebase-ui>
    </div>-->
    <register-client id="register-client"></register-client>
    <user-not-found id="user-not-found"></user-not-found>
    <network-error id="network-error"></network-error>
  </div>
</template>

<script>
// import FirebaseUI from "./FirebaseUI.vue";
import RegisterClient from './RegisterClient.vue'
import UserNotFound from './UserNotFound.vue'
import NetworkError from './NetworkError.vue'
import { mapState } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      firebase: state => state.user.firebase,
      userData: state => state.user.data,
      clientUser: state => state.user.clientUser,
      ref: state => state.user.ref,
      clients: state => state.user.clients,
      desktop: state => state.user.desktop,
      app: state => state.user.app,
      reload: state => state.user.reload
    })
  },
  watch: {
    ref: function (ref) {
      const $auth = $(this.$el)
      ref.id == null ? $auth.show() : $auth.hide()
      $(window).trigger('resize')
    },
    reload: function (reload) {
      if (reload) {
        this.fetchAll()
        this.$store.dispatch('user/set_property', {
          property: 'reload',
          value: false
        })
      }
    }
  },
  created () {
    const userParam = this.getUrlParam('user')
    this.$store.state.userId = userParam && userParam.trim() ? userParam : null
    this.$store.state.token = this.getUrlParam('computer')
    this.$store.state.idToken = this.getUrlParam('idToken')
    this.$store.state.provider = this.getUrlParam('provider')
  },
  mounted () {
    var _this = this
    _this.$root.$on('user-login', async user => {
      document.body.classList.add('logged-in')
      const userSnapshot = await user.get()
      console.log('userSnapshot.id', userSnapshot.id)

      if (_this.clientUser) {
        const updateVisitIfPresent = () => {
          if (!document.hidden) {
            user.update({
              lastVisit: _this.$store.state.firebase.firestore.FieldValue.serverTimestamp()
            }).catch(function(e) {
              console.warn('[Auth] lastVisit update failed:', e && e.code);
            })
          }
        }

        updateVisitIfPresent()
        document.addEventListener('visibilitychange', () =>
          updateVisitIfPresent()
        )
      }

      const userData = userSnapshot.data()
      const { lock, block, payment, account } = userData

      // const subscriptionExpires = account ? account.subscription : null;
      // if (subscriptionExpires) {
      //   const { trial, expiresAt } = subscriptionExpires;
      //   console.log({ trial });
      //   console.log(moment.unix(expiresAt.seconds).fromNow());
      // }

      _this.$payment = $('#payment')
      window.lock = lock
      if (block) {
        $('#payment-lock').modal({
          backdrop: 'static',
          keyboard: false
        })
      } else if (lock) {
        $('#due-trial').text(moment(lock.toDate()).fromNow())
        const trialActive = new Date().getTime() < lock.toDate().getTime()
        _this.$payment.modal({
          backdrop: trialActive ? true : 'static',
          keyboard: false
        })
        if (trialActive) {
          $('#trial-payment-close').show()
        }
      }
      // if (!lock || new Date().getTime() < lock.toDate().getTime()) {
      this.$store.dispatch('user/subscribe', user).then(response => {
        _this.fetchAll()
      })
      // }
    })

    _this.$root.$on('user-logout', function () {
      document.body.classList.remove('logged-in')
      var _this = this
      _this.$store.dispatch('user/unsubscribe').then(async () => {
        await _this.$store.state.firebase.auth().signOut()
        window.location.href = window.location.host.startsWith('localhost')
          ? 'http://localhost:9002/onboarding/user?signout'
          : 'https://maprint.com/onboarding/user?signout'
      })
    })

    _this.$store.state.firebase.auth().onAuthStateChanged(
      function (user) {
        const url = new URL(window.location.href)
        const userParam = url.searchParams.get('user')
        if (!userParam) {
          window.history.replaceState('', '', '/')
        } else {
          if (userParam === 'register') {
            $('#register-client').modal({
              backdrop: 'static',
              keyboard: false
            })
            return
          }
          // todo: if logging out show message to try to reload
        }
        if (_this.$i18n.locale == 'pt') {
          _this.$store.state.firebase.auth().languageCode = 'pt-PT'
        } else {
          _this.$store.state.firebase.auth().languageCode = _this.$i18n.locale
        }
        if (user) {
          var currentUser = _this.$store.state.firebase.auth().currentUser
          var uid = currentUser.uid
          console.log(uid)
          var userId = uid

          var userRef = _this.$store.state.db.collection('users').doc(userId)
          userRef.get().then(function (user) {
            if (user.exists && uid !== '5nvqWd056kY21aIkCDcXG4OZfq62') {
              _this.$root.$emit('user-login', user.ref)
              user.ref.update({
                lastVisit: _this.$store.state.firebase.firestore.FieldValue.serverTimestamp()
              })
            } else {
              _this.$store.state.db
                .collection('system')
                .doc('admin')
                .get()
                .then(function (admin) {
                  if (admin.exists) {
                    console.log('admin found')
                    var userRef = _this.$store.state.db
                      .collection('users')
                      .doc(admin.data().user.id)
                    userRef.get().then(function (user) {
                      if (user.exists) {
                        _this.$root.$emit('user-login', user.ref)
                      }
                    })
                  } else {
                    alert('admin not found')
                  }
                })
                .catch(function (e) {
                  console.log(e)
                  console.log(
                    `new user set merge: ${userRef.id} - ${currentUser.email}`
                  )
                  userRef
                    .set(
                      {
                        name: currentUser.displayName,
                        email: currentUser.email
                      },
                      { merge: true }
                    )
                    .then(function () {
                      _this.$root.$emit('user-login', userRef)
                    })
                })
            }
          })
        } else {
          const { provider, idToken } = _this.$store.state
          if (idToken) {
            if (provider === 'GoogleAuthProvider') {
              const credential = _this.$store.state.firebase.auth[
                provider
              ].credential(idToken)
              _this.$store.state.firebase
                .auth()
                .signInWithCredential(credential)
                .catch(error => {
                  // Handle Errors here.
                  const { code: errorCode, message: errorMessage } = error
                  console.log(errorCode)
                  console.log(errorMessage)
                  if (errorCode === 'auth/invalid-credential') {
                    _this.$store.state.firebase
                      .auth()
                      .signInWithCustomToken(idToken)
                  }
                })
            } else if (!provider) {
              _this.$store.state.firebase.auth().signInWithCustomToken(idToken)
            }
            _this.$store.state.provider = null
            _this.$store.state.idToken = null
          } else {
            _this.checkAnonymousLogin()
          }
        }
      },
      function (error) {
        console.log(error)
      }
    )
  },
  methods: {
    fetchAll: async function () {
      const _this = this
      _this.$clientsLoader = $('#clientsLoader')
      if (!_this.clientUser) {
        _this.$clientsLoader.addClass('md-show')
      }
      // const interval = setInterval(() => {
      //   const totalHeapSizeBytes = window.performance.memory.totalJSHeapSize;
      //   const totalHeapSizeMB = totalHeapSizeBytes / (1024 * 1024); // Convert bytes to megabytes
      //   console.log(`Total JS Heap Size: ${totalHeapSizeMB.toFixed(0)} MB`);
      // }, 1000);
      console.time('fetchAll')
      if (!endDate.isSame(new Date(), 'day')) {
        // otherwise the endDate is not synced and we have a problem to show printers updated for today
        location.reload()
      }
      var data = []
      let clients = []
      if (_this.userData.clients !== undefined) {
        clients = _this.userData.clients
      }
      if (_this.userData.computer) {
        clients.push(_this.ref)
      }
      clients = _this.unique(clients)
      if (clients.length > 0) {
        const $loadedClients = $('#loaded-clients')

        function debounce (func, delay) {
          let timerId

          return function (...args) {
            clearTimeout(timerId)
            timerId = setTimeout(() => {
              func.apply(this, args)
            }, delay)
          }
        }

        const updateLoadedClients = debounce((count, delay) => {
          $loadedClients.text(count.toString())
        }, delay)

        $loadedClients.text('0')
        $('#total-clients').text(clients.length.toString())

        let loadedClients = 0
        const processClient = async clientRef => {
          const clientSnapshot = await clientRef.get()
          loadedClients++
          // Call the debounce function to update the text
          updateLoadedClients(loadedClients, 500)
          if (!clientSnapshot.exists) return
          const client = clientSnapshot.data()
          client.snapshot = clientSnapshot
          if (client.computer === undefined) {
            return client
          }
          const computerRef = client.computer
          const computerSnapshot = await computerRef.get()
          if (!computerSnapshot.exists) {
            return client
          }
          const computer = computerSnapshot.data()
          computer.snapshot = computerSnapshot
          client.computer = computer
          const printersSnapshot = await computerRef
            .collection('printers')
            .get()
          const printers = []
          if (
            !window.lock ||
            new Date().getTime() < window.lock.toDate().getTime()
          ) {
            for (const printerSnapshotDoc of printersSnapshot.docs) {
              const {
                time,
                macAddress,
                hostName,
                ip,
                status,
                parsed
              } = printerSnapshotDoc.data()
              const printer = {
                id: printerSnapshotDoc.id,
                path: printerSnapshotDoc.ref.path,
                time,
                macAddress,
                hostName,
                ip,
                status,
                parsed
              }
              printers.push(printer)
            }
          }
          client.computer.printers = printers

          const services = []
          const servicesSnapshot = await computerRef
            .collection('service')
            .get()
          for (const serviceSnapshot of servicesSnapshot.docs) {
            const service = serviceSnapshot.data()
            service.snapshot = serviceSnapshot
            services.push(service)
          }
          client.computer.services = services
          return client
        }

        const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

        const concurrency = 150
        const limitBeforeFlush = concurrency * 2

        let requestsAccumulatedBeforeFlush = 0
        const requestsInParallelInterval = setInterval(() => {
          if (requestsAccumulatedBeforeFlush > limitBeforeFlush * 2) {
            requestsAccumulatedBeforeFlush = 0
          }
        }, 1000)

        const makeRequests = clients.map(clientRef => () =>
          processClient(clientRef)
        )
        const results = []
        let started = 0

        const recurse = async () => {
          const i = started++
          requestsAccumulatedBeforeFlush++
          const makeRequest = makeRequests.shift()
          if (!makeRequest) return

          try {
            requestsAccumulatedBeforeFlush++
            if (requestsAccumulatedBeforeFlush > limitBeforeFlush) {
              await delay(2500)
            }
            const result = await makeRequest()
            results[i] = { status: 'fulfilled', value: result }
          } catch (error) {
            results[i] = { status: 'rejected', reason: error }
          }

          await recurse()
        }

        await Promise.all(Array.from({ length: concurrency }, recurse))

        const data = results.map(result =>
          result.status === 'fulfilled' ? result.value : undefined
        )

        clearInterval(requestsInParallelInterval)
        console.timeEnd('fetchAll')
        _this.$root.$children[0].$refs.topheader.isRefreshed = false
        _this.$clientsLoader.removeClass('md-show')
        _this.$store.dispatch('user/dataFetched', data)
      } else {
        if (_this.$root.$children[0].$refs.topheader != null) {
          _this.$root.$children[0].$refs.topheader.isRefreshed = false
        }
        _this.$clientsLoader.removeClass('md-show')
        _this.$store.dispatch('user/dataFetched', data).then(function () {
          if (_this.$root.$children[0].$refs.topheader != null) {
          } else {
            _this.$root.$emit('user-logout')
          }
        })
      }
    },
    checkAnonymousLogin: function () {
      var _this = this
      if (_this.$store.state.userId != null) {
        var user = _this.$store.state.db
          .collection('users')
          .doc(_this.$store.state.userId)
        _this.anonymousUserLogin(user)
      } else if (_this.$store.state.token != null) {
        _this.$store.state.db
          .collection('computers')
          .doc(_this.$store.state.token)
          .get()
          .then(function (computer) {
            if (computer.exists) {
              var user = computer.data().user
              _this.anonymousUserLogin(user)
            } else {
              _this.$root.$emit('user-logout')
            }
          })
      } else {
        _this.$root.$emit('user-logout')
      }
    },
    throttle: (func, wait) => {
      let timeout
      let lastCallArgs

      return function () {
        const context = this
        const args = arguments
        lastCallArgs = args

        if (!timeout) {
          timeout = setTimeout(function () {
            func.apply(context, lastCallArgs)
            lastCallArgs = null
            timeout = null
          }, wait)
        }
      }
    },
    anonymousUserLogin: function (user) {
      var _this = this
      var $message = $('#message')
      if (user != undefined) {
        user
          .get()
          .then(function (user) {
            console.log(user)
            if (user.exists) {
              let first = true
              _this.$root.$emit('user-login', user.ref)
              const timeout = setInterval(() => {
                if (_this.userData.computer) {
                  clearInterval(timeout)
                  const printersRef = _this.userData.computer.collection(
                    'printers'
                  )

                  const fetchFunction = () => {
                    _this.$root.$children[0].$refs.auth.fetchAll()
                    $message.removeClass('md-show')
                  }

                  const throttledFunction = _this.throttle(fetchFunction, 2500)

                  const unsubscribe = printersRef.onSnapshot(printers => {
                    if (!printers.empty) {
                      throttledFunction()
                    } else {
                      $message.addClass('md-show')
                    }
                  })
                } else {
                  if (first) {
                    first = false
                    $message.addClass('md-show')
                  }
                }
              }, 1000)
            } else {
              if (_this.$store.state.userId != null) {
                $('#user-not-found').modal({
                  backdrop: 'static',
                  keyboard: false
                })
              } else {
                _this.$root.$emit('user-logout')
              }
            }
          })
          .catch(function (error) {
            console.error('[Auth] Error in anonymousUserLogin:', error)
            
            // Check if this is a network/connection error
            const errorMessage = error && error.message ? error.message.toLowerCase() : ''
            const isNetworkError = error && (
              error.code === 'unavailable' ||
              error.code === 'failed-precondition' ||
              errorMessage.includes('unavailable') ||
              errorMessage.includes('failed to get document') ||
              errorMessage.includes('network') ||
              errorMessage.includes('connection')
            )
            
            if (_this.$store.state.userId != null) {
              // Show network error modal if it's a connection issue
              if (isNetworkError) {
                console.warn('[Auth] Network error detected, showing network error modal')
                $('#network-error').modal({
                  backdrop: 'static',
                  keyboard: false
                })
              } else {
                // Show user not found modal for other errors
                $('#user-not-found').modal({
                  backdrop: 'static',
                  keyboard: false
                })
              }
            } else {
              _this.$root.$emit('user-logout')
            }
          })
      } else {
        _this.$root.$emit('user-logout')
      }
    }
  },
  components: {
    // "firebase-ui": FirebaseUI,
    'register-client': RegisterClient,
    'user-not-found': UserNotFound,
    'network-error': NetworkError
  }
}
</script>
<style lang="scss" scoped>
#app {
  #app-auth-container {
    display: none;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: calc(50% - 166px);
    transform: translateY(-50%);
    background: white;
    border: 1px solid #9f9f9f;
    color: black;
    border-radius: 5px;
  }
  // .auth-header {
  //   font-size: 1.8rem;
  //   padding: 20px;
  //   text-align: center;
  //   width: 332px;
  //   margin: 0 auto;
  //   border-bottom: 0;
  //   .auth-title {
  //     font-weight: bold;
  //     text-transform: capitalize;
  //   }
  //   .auth-subtitle {
  //     font-size: 1.25rem;
  //   }
  // }
  .register-header {
    font-size: 1.4rem;
    padding: 1.5rem;
    .title {
      font-weight: bold;
    }
    .subtitle {
      font-size: 1.25rem;
    }
    .form {
      padding: 1rem 0;
      .form-input {
        padding: 0.25rem;
        input {
          margin: 0.5rem 0;
          padding: 0.5rem;
          outline: none;
          font-size: 1.1rem;
          line-height: 1.1rem;
          min-width: 20rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue